module.exports = __webpack_public_path__ + "static/media/tournament-bg-layer.80e8e4ad.svg";